import React from "react";

function Footer(){
    return (<div className="footer">
                <p>Home is behind, the world ahead.</p>
            </div>);
}

export default Footer;